import React, { memo } from 'react'
import { Text } from 'common-components'
import * as Styled from './styled'

interface IRatingDotsProps {
  score: number
}

const DOT_KEYS = ['d1', 'd2', 'd3', 'd4', 'd5'] as const
const TOTAL_DOTS = DOT_KEYS.length

const RatingDots: React.FC<IRatingDotsProps> = ({ score }) => {
  // Score is 0–10, dots are 0–5 — halve and round, then clamp in case the
  // input falls outside the expected range.
  const filledCount = Math.min(TOTAL_DOTS, Math.max(0, Math.round(score / 2)))

  return (
    <Styled.Wrapper>
      <Styled.DotsRow>
        {DOT_KEYS.map((key, index) => (
          <Styled.Dot key={key} $filled={index < filledCount} $score={score} />
        ))}
      </Styled.DotsRow>
      <Text type="p" color="secondarySemiDark" lineHeight="1">
        {score.toFixed(1)}/10
      </Text>
    </Styled.Wrapper>
  )
}

export default memo(RatingDots)
